// extracted by extract-css-chunks-webpack-plugin
module.exports = {"heading":"shipping-address__heading__12jfH","address":"shipping-address__address__bH2l_"};